module.exports = __webpack_public_path__ + "static/kata-641ee628a173ec8c76826847e48635c6.jpg";